/**
 * Employee Web — `/me/profile/documents` tab route (Plan 05.2-05).
 *
 * Re-uses the same <DocumentList> data path as `/me/documents`. Both URLs
 * are valid: nav.ts links to `/me/documents` (top-level), the profile shell
 * exposes `/me/profile/documents` as a tab.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { DocumentsTab } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/profile/documents")({
  staticData: { breadcrumb: { labelKey: "me-profile:tabs.documents" } },
  component: DocumentsTabRoute,
});

function DocumentsTabRoute(): JSX.Element {
  return <DocumentsTab />;
}
